import axios, { API_URL } from './BaseService';

const QUICK_STRATEGY_URL = `${API_URL}/quick-strategy/`;

export async function createQuickStrategy(strategyData) {
    const response = await axios.post(QUICK_STRATEGY_URL, strategyData);
    return response.data;
}




